let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("58UdM")).then(() => parcelRequire('8KSlr'));